import type { TFunction } from 'i18next';

/** Every `audit_log.action` the migrations write (P2 lifecycle and members, P6 sharing). */
export const AUDIT_ACTIONS = [
  'member.add',
  'member.remove',
  ...(['board', 'project'] as const).flatMap((k) => ['archive', 'unarchive', 'trash', 'restore', 'purge'].map((a) => `${k}.${a}`)),
  'share_link.create',
  'share_link.revoke',
  'share_link.redeem',
  'grant.set',
  'grant.remove',
  'invitation.create',
  'invitation.accept',
  'invitation.revoke',
];

const known = new Set(AUDIT_ACTIONS);

/** Readable label of an audit action; an unknown action is shown as is. */
export function auditLabel(action: string, t: TFunction): string {
  return known.has(action) ? t(`audit.actions.${action.replace('.', '_')}`) : action;
}
